import { Entity, Color, Asset, Quat, StandardMaterial, Camera } from 'playcanvas';
import { BLEND_NORMAL, SPECOCC_AO, TONEMAP_ACES, SKYTYPE_BOX, SHADOW_PCF5_16F } from 'playcanvas';
import loadSkybox from './skybox.js';
import { CameraFrame } from './camera-frame.js';


const initialize = async (app) => {
    app.root.addComponent('script');
    app.root.script.create('input');

    CameraFrame.__name = 'cameraFrame';
    app.scripts.add(CameraFrame)


    // camera
    const camera = new Entity('camera');
    camera.addComponent('camera', {
        clearColor: new Color(0, 0, 0, 0),
        toneMapping: TONEMAP_ACES
    });
    camera.setPosition(0, 1.1, 2.6);
    camera.setLocalEulerAngles(-15, 0, 0);
    camera.addComponent('script');
    camera.script.create('camera');

    // post effects
    camera.script.create('cameraFrame');
    //      general
    camera.script.cameraFrame.rendering.samples = 4; // anti-aliasing
    camera.script.cameraFrame.rendering.toneMapping = TONEMAP_ACES; // tonemapping
    //      ssao
    camera.script.cameraFrame.ssao.type = 'lighting';
    camera.script.cameraFrame.ssao.intensity = 1;
    camera.script.cameraFrame.ssao.power = 1;
    camera.script.cameraFrame.ssao.minAgle = 15;
    camera.script.cameraFrame.ssao.radius = 0.5;
    //      bloom
    camera.script.cameraFrame.bloom.enabled = true;
    //      vignette
    camera.script.cameraFrame.vignette.enabled = true;

    app.root.addChild(camera);


    // light
    const light = new Entity('light');
    light.addComponent('light', {
        type: 'directional',
        castShadows: true,
        shadowType: SHADOW_PCF5_16F,
        shadowResolution: 2048,
        shadowDistance: 8,
        shadowBias: 0.01,
        normalOffsetBias: 0.01
    });
    // light.setLocalPosition(0, 0, -4);
    light.setLocalEulerAngles(60, 30, 0);
    camera.addChild(light);


    // floor material
    const floorMaterial = new StandardMaterial();
    floorMaterial.diffuse.set(0.1, 0.1, 0.1); 
    floorMaterial.metalness = 0;
    floorMaterial.useMetalness = true;
    floorMaterial.glossInvert = false;
    floorMaterial.shininess = 100;
    floorMaterial.blendType = BLEND_NORMAL;
    floorMaterial.occludeSpecular = SPECOCC_AO;
    floorMaterial.aoMapChannel = 'g';
    floorMaterial.glossMapChannel = 'b';
    floorMaterial.opacityMapChannel = 'r';
    floorMaterial.glossMapTiling.set(2, 2);
    floorMaterial.opacity = 0.7;
    floorMaterial.depthWrite = false;
    floorMaterial.useFog = false;

    // floor
    const floor = new Entity('floor');
    floor.addComponent('render', {
        type: 'plane',
        material: floorMaterial
    });
    floor.setLocalScale(4, 4, 4);
    app.root.addChild(floor);


    const textureFloor = new Asset(
        'texture-floor',
        'texture',
        { url: '/img/floor.png' }
    );

    textureFloor.once('load', () => {
        floorMaterial.aoMap = textureFloor.resource;
        floorMaterial.glossMap = textureFloor.resource;
        floorMaterial.opacityMap = textureFloor.resource;
        floorMaterial.update();
    });

    app.assets.add(textureFloor);
    app.assets.load(textureFloor);


    // load skybox (low)
    loadSkybox(app, '/img/skybox-low.hdr', (assetLow, skybox, prefiltered) => {
        app.scene.skybox = skybox;
        app.scene.envAtlas = prefiltered;

        // mid
        loadSkybox(app, '/img/skybox-mid.hdr', (assetMid, skybox, prefiltered) => {
            app.scene.skybox = skybox;
            app.scene.envAtlas = prefiltered;
            assetLow.unload();

            // high
            loadSkybox(app, '/img/skybox-high.hdr', (asset, skybox, prefiltered) => {
                app.scene.skybox = skybox;
                app.scene.envAtlas = prefiltered;
                assetMid.unload();
            });
        });
    });

    app.scene.skyboxIntensity = 0.5;
    app.scene.skyboxRotation = new Quat().setFromEulerAngles(0, -90, 0);

    // skybox to be rendered as a cube
    app.scene.sky.type = SKYTYPE_BOX;
    app.scene.sky.center.set(0, 0.6, 0);
    app.scene.sky.node.setLocalScale(4.7, 4, 7);

    app.scene.exposure = 1.0;
};


export { initialize };